import {
	Component,
	ChangeDetectionStrategy,
	inject,
	signal,
	input,
} from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { ApiService, senderFactory } from "@app/services/api.service"
import { StoreService } from "@app/services/store.service"
import { SpinOrContent } from "@app/utils/utils.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

@Component({
	selector: "email-btn",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		GenTableDisplayComponent,
		SpinOrContent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-spin-or-content [isSpin]="send.isLoading()">
			<button
				class="btn btn-icon"
				titleLang="send_by_email"
				icon="email"
				(click)="email()"
			></button>
		</app-spin-or-content>
		@if (modalProps()) {
			<app-modal-wrap
				(onClose)="modalProps.set(null)"
				title="contactways"
				modalWrapperClass="modal-wide"
			>
				<app-gen-table-display
					(onClose)="modalProps.set(null); $event?.length && send.run($event)"
					tableName="contactways"
					[filterField]="type() + '_id'"
					[filterFieldValue]="row().id"
					fieldNameInItemToDisplay="contactway"
					isCheckItems
					[filterFieldApiObject]="modalProps().filterFieldApiObject"
					[emailsAndPhoneValidation]="modalProps().emailsAndPhoneValidation"
				/>
			</app-modal-wrap>
		}
	`,
})
export class EmailBtn {
	modalProps = signal<any>(null)
	type = input.required<string>()
	row = input.required<any>()

	apiService = inject(ApiService)
	store = inject(StoreService)

	send = senderFactory({
		fn: (arr: any[] = []) =>
			this.apiService.post("email_fill", {
				id: this.row().latestFill.id,
				person_id: this.row().id,
				person_type: this.type(),
				contactway_ids: arr.map(({ id }) => id),
			}),
	})

	async email() {
		if (this.type() === "user") {
			this.send.run()
			return null
		}
		this.modalProps.set({
			...this.store.phoneEmailValidationAttrs(),
		})
	}
}
